import { Column } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';

interface TransportSupportAvatarProps {
  size: number;
}

export function TransportSupportAvatar({ size }: TransportSupportAvatarProps) {
  return (
    <Column
      alignItems="center"
      backgroundColor="surface.info.subtle"
      borderRadius="radius.full"
      height={size}
      justifyContent="center"
      width={size}
    >
      <Text fontSize={Math.round(size * 0.5)}>🚚</Text>
    </Column>
  );
}

export { isTransportSupportChannel } from './transport-support-avatar.utils';
